// Imports Angular
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/** @namespace ContenedorFormularioComponent */
//import { ContenedorFormularioComponent } from './components/formulario-experto/contenedor-formulario/contenedor-formulario.component';
//import { ContenedorFormularioComponent as ContenedorFormularioNoExpertoComponent } from './components/formulario-no-experto/contenedor-formulario/contenedor-formulario.component';
import { InitContainerComponent } from './components/init-container/init-container.component';

/**
 * Routes associated to components
 * @constant
 * @type {Array<JSON>}
 */
const routes: Routes = [
	{ path: '', component: InitContainerComponent },
    //{ path: '', component: InitContainerComponent },
    //{ path: 'formulario-no-experto', component: ContenedorFormularioNoExpertoComponent }
];

/** @module NgModule main app */
@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ],
    providers: []
})

/**
* Module main app routing
* @class
*/
export class AppRoutingModule { }



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/app-routing.module.ts